import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { APPLICATION_LINK_PROPS } from "../config/applicationForm";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink-deep border-t border-white/5">
      {/* Apply CTA band */}
      <div className="border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-12 lg:py-14 grid md:grid-cols-[1fr_auto] gap-6 items-center">
          <div>
            <div className="text-[10.5px] tracking-[0.34em] uppercase text-gold">
              Ready to Begin?
            </div>
            <div className="mt-3 font-serif text-white text-[22px] sm:text-[26px] lg:text-[30px] leading-[1.15] tracking-[-0.012em]">
              Apply to the{" "}
              <span className="italic text-azure-soft">Murabbi Youth Initiative</span>.
            </div>
          </div>
          <a
            {...APPLICATION_LINK_PROPS}
            data-testid="footer-apply-now-btn"
            className="inline-flex items-center justify-center gap-3 bg-azure hover:bg-[#5C9BEC] text-white px-8 py-4 text-[11px] tracking-[0.32em] uppercase font-medium transition-all whitespace-nowrap"
          >
            Apply Now
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif text-[18px] tracking-[0.18em] text-white">IYARE OMORUYI</div>
          <div className="text-[10px] tracking-[0.32em] text-gold/90 mt-2">
            EDUCATOR. SPEAKER. MURABBI.
          </div>
          <p className="text-white/60 text-sm mt-6 max-w-sm leading-relaxed">
            Reviving the timeless role of the Murabbi to teach minds and cultivate souls
            in the modern world.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div>
            <div className="text-[11px] tracking-[0.28em] uppercase text-gold mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-white">About</Link></li>
              <li><Link to="/podcast" className="text-white/70 hover:text-white">Podcast</Link></li>
              <li><Link to="/speaking" className="text-white/70 hover:text-white">Speaking</Link></li>
              <li><Link to="/consulting" className="text-white/70 hover:text-white">Consulting</Link></li>
              <li><Link to="/books" className="text-white/70 hover:text-white">Books</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-[11px] tracking-[0.28em] uppercase text-gold mb-4">Connect</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/contact" className="text-white/70 hover:text-white">Contact</Link></li>
              <li><a href="#" className="text-white/70 hover:text-white">Newsletter</a></li>
              <li><a href="#" className="text-white/70 hover:text-white">Instagram</a></li>
              <li><a href="https://www.youtube.com/@themurabbichannel" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube-link" className="text-white/70 hover:text-white">YouTube</a></li>
            </ul>
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-gold mb-4">Stay in touch</div>
          <p className="text-white/60 text-sm mb-4">
            Reflections on faith, leadership and the cultivation of souls.
          </p>
          <form className="flex border border-white/15" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              required
              placeholder="your@email.com"
              data-testid="footer-newsletter-input"
              className="flex-1 bg-transparent px-4 py-3 text-sm placeholder-white/40 text-white outline-none"
            />
            <button
              type="submit"
              data-testid="footer-newsletter-submit"
              className="text-[11px] tracking-[0.28em] uppercase bg-azure text-white px-4 hover:bg-azure/90 transition-colors"
            >
              Join
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-xs text-white/40 tracking-wide">
            © {new Date().getFullYear()} Iyare Omoruyi. All rights reserved.
          </div>
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/40">
            Teaching Minds · Cultivating Souls
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
